import type { I18nContextValue } from './const';
import { createContext } from 'react';

/**
 * I18nContext - 提供当前语言
 */
export const I18nContext = createContext<I18nContextValue | null>(null);
